import { uppyMultipleFileUpload } from "../uppyFileUpload";
import baguetteBox from "baguettebox.js";
import { Turbo } from "@hotwired/turbo-rails"
import { Application } from "@hotwired/stimulus"
import CookieConsentController from "../controllers/cookie_consent_controller"

Turbo.session.drive = false

require('baguettebox.js/dist/baguetteBox.css')

// LOAS-only Stimulus instance. The shared `app/assets/javascripts/application.js.coffee`
// (loaded via `javascript_include_tag 'application'`) is Sprockets-served and
// doesn't boot Stimulus, so we start an instance here for the pack that only
// loads when SITE == 'loas'.
const stimulus = Application.start()
stimulus.register("cookie-consent", CookieConsentController)

document.addEventListener("DOMContentLoaded", event => {
  baguetteBox.run("[data-image-lightbox]");
  Array.from(document.querySelectorAll('.uppy-upload-file')).forEach((fileInput) => {
    uppyMultipleFileUpload(fileInput)
  })
})
